import { IsoDate, IsoDateTime, IsoDateTimeTz, IsoTimeTz } from '../../types/iso-date';
import { deconstructDate } from '../helper/deconstruct-date.function';
import { constructDate } from '../helper/construct-date.function';

export function setTimeTz<T extends IsoDate | IsoDateTime | IsoDateTimeTz>(date: T, time: IsoTimeTz ): IsoDateTimeTz {
  const deconstructedDate = deconstructDate(date);
  const deconstructedTime = deconstructDate(time);
  return constructDate({...deconstructedDate, ...deconstructedTime, _type: 'dateTimeTz'});
}
